const Pagetop = function() {
  const $btn = $('.l-pagetop a');
  const $vp = ($('.p-good-pricing').length > 0) ? $('.p-good-pricing').offset().top : 4500 ; 

  $btn.on('click', function () {
    $('html, body').stop().animate({ scrollTop: 0 }, 500, 'swing');
  });

  // スクロール量によってヘッダーに指定クラスを付け外しする
  $(window).on('my_load my_scroll', function (e, mediaQuery) {
    if (mediaQuery === 'sm') {
      $btn.closest('.l-pagetop').removeClass('l-pagetop--active');
    }
    if (
      ($(window).scrollTop() + $(window).innerHeight()) > $vp) {
      $btn.closest('.l-pagetop').addClass('l-pagetop--active');
    } else {
      $btn.closest('.l-pagetop').removeClass('l-pagetop--active');
    }
  });
};

export default Pagetop;
